import {DomainEvent} from './DomainEvent';
import {TeamSeason} from '../resources/TeamSeason';

export class TeamSeasonUpdated extends DomainEvent<TeamSeason> {}
